import routerOptions0 from "/opt/build/repo/node_modules/.pnpm/nuxt@3.15.4_@parcel+watcher@2.5.6_@types+node@20.19.32_cac@6.7.14_db0@0.3.4_eslint@8.57_f74128c39824ad93d1c439882146bd58/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}